import { Typography, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { Container, List, ListItem } from './animation';
import { useGetTextForAnimation } from '@hooks';
import { useMemo } from 'react';
import { rem } from '@helpers';

export const ListTextAnimation: React.FC = () => {
	const listTextAnimation = useGetTextForAnimation();
	const { palette } = useTheme();
	const hasText = listTextAnimation.length > 0;
	const listItems = useMemo(() => {
		let items = undefined;
		if (hasText) {
			items = listTextAnimation.map((textAnimation, index) => {
				return (
					<ListItem key={index}>
						<Typography
							alternativeStyleProperties={{
								color: palette.global.ui9,
							}}
							appearance="body-100-02"
						>
							{textAnimation.text}
						</Typography>
					</ListItem>
				);
			});
		}
		return items;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasText]);

	return (
		<>
			{hasText && (
				<div style={{ width: rem(300) }}>
					<Container>
						<List style={{ padding: 0 }}>{listItems}</List>
					</Container>
				</div>
			)}
		</>
	);
};
